import {setCacheNameDetails as workbox_core_setCacheNameDetails} from 'C:/xampp/htdocs/ypnn/node_modules/workbox-core/setCacheNameDetails.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'C:/xampp/htdocs/ypnn/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */





workbox_core_setCacheNameDetails({prefix: "ypnn"});


self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/css/315.24a585bf.css",
    "revision": null
  },
  {
    "url": "/css/848.c57f3bb5.css",
    "revision": null
  },
  {
    "url": "/css/app.ecce463e.css",
    "revision": null
  },
  {
    "url": "/frontend/css/admin_style.css",
    "revision": "377f7b42d8466a8701bd20bc99754d3b"
  },
  {
    "url": "/frontend/css/ajax-loader.gif",
    "revision": "99e390c72524d78f1b37e15d104c02d8"
  },
  {
    "url": "/frontend/css/animate.min.css",
    "revision": "49a9d2997750b3ff77389e0909374af3"
  },
  {
    "url": "/frontend/css/bootstrap-social.css",
    "revision": "6156b57af7268ca3fab73797cbeb12ef"
  },
  {
    "url": "/frontend/css/bootstrap-theme.min.css",
    "revision": "46d96593303e4c8666f497bb7602c999"
  },
  {
    "url": "/frontend/css/bootstrap.min.css",
    "revision": "2f624089c65f12185e79925bc5a7fc42"
  },
  {
    "url": "/frontend/css/bootstrap4.min.css",
    "revision": "f411c136e2bb302ada2120b3eb1d5bc3"
  },
  {
    "url": "/frontend/css/chosen.min.css",
    "revision": "0641507d409544a0e56fbf68f4bed7bc"
  },
  {
    "url": "/frontend/css/common.css",
    "revision": "bec5e4aa2343a3da829a13d990d74c90"
  },
  {
    "url": "/frontend/css/dataTables.bootstrap.min.css",
    "revision": "90e568434967792c6b3bb9650ae6ebc8"
  },
  {
    "url": "/frontend/css/dataTables.jqueryui.min.css",
    "revision": "d5861c9150c43df231327dbd5b90f30c"
  },
  {
    "url": "/frontend/css/dataTables.responsive.css",
    "revision": "8fa6f4c97214a80551d5d64a3d0dc23a"
  },
  {
    "url": "/frontend/css/datepicker.css",
    "revision": "f0f519c66ea65bb3725ab268be978d60"
  },
  {
    "url": "/frontend/css/font-awesome.min.css",
    "revision": "4083f5d376eb849a458cc790b53ba080"
  },
  {
    "url": "/frontend/css/fontawesome.css",
    "revision": "02c805d8d2c5f16d24dd2a1f01218138"
  },
  {
    "url": "/frontend/css/jquery-ui.min.css",
    "revision": "609fa5e22a8d5b47a75bc8ed05488c2f"
  },
  {
    "url": "/frontend/css/jquery.dataTables.min.css",
    "revision": "56844147e0444751df7696c995b93b7e"
  },
  {
    "url": "/frontend/css/lightbox.css",
    "revision": "06fd76c56815398d4e8a0771badea40d"
  },
  {
    "url": "/frontend/css/metisMenu.min.css",
    "revision": "bb3f6f86f3feb94b2ba7b43c9d315c54"
  },
  {
    "url": "/frontend/css/morris.css",
    "revision": "36e70bf949fcdb7d0fe55fc16ce86445"
  },
  {
    "url": "/frontend/css/nouislider.min.css",
    "revision": "d2509b2c466924831bace0fb8dfce960"
  },
  {
    "url": "/frontend/css/nprogress.css",
    "revision": "9dc52b7dd289312c1437a3e66ca7662c"
  },
  {
    "url": "/frontend/css/owl.carousel.css",
    "revision": "b51416af9e8adbe3d16f5f2526aba221"
  },
  {
    "url": "/frontend/css/public.css",
    "revision": "8852a2312bfcac59ae2bc5a4a41b1791"
  },
  {
    "url": "/frontend/css/responsive.bootstrap.min.css",
    "revision": "ccc0f0d9ac285d86ff666c33007ccb0e"
  },
  {
    "url": "/frontend/css/sb-admin-2.min.css",
    "revision": "833551346176cfd313d795f4481ac7d7"
  },
  {
    "url": "/frontend/css/slick-theme.css",
    "revision": "f9faba678c4d6dcfdde69e5b11b37a2e"
  },
  {
    "url": "/frontend/css/slick.css",
    "revision": "f38b2db10e01b1572732a3191d538707"
  },
  {
    "url": "/frontend/css/style.css",
    "revision": "0894a88eb0992a467b4087c9131d7316"
  },
  {
    "url": "/frontend/css/sweetalert2.all.min.js",
    "revision": "31f816aeeba57b707b38a24dca1d6145"
  },
  {
    "url": "/frontend/css/sweetalert2.min.css",
    "revision": "64a3cfdbd3bf90f08392acedc68c42c1"
  },
  {
    "url": "/frontend/fonts/FontAwesome.otf",
    "revision": "5dc41d8fe329a22fa1ee9225571c843e"
  },
  {
    "url": "/frontend/fonts/PostinkantajaJob.ttf",
    "revision": "21a0b975f99cfde864d4931cb1167253"
  },
  {
    "url": "/frontend/fonts/Punksnotdead.ttf",
    "revision": "5c0e4b6e2b08d3c476eff50d19eb6e0d"
  },
  {
    "url": "/frontend/fonts/fa-brands-400.eot",
    "revision": "dcd6364b5f436685f2ea48eb129863f1"
  },
  {
    "url": "/frontend/fonts/fa-brands-400.ttf",
    "revision": "c1367e975c8b834f9db493958d5c499a"
  },
  {
    "url": "/frontend/fonts/fa-brands-400.woff",
    "revision": "4b280becfd11224f26d35848eadf0a32"
  },
  {
    "url": "/frontend/fonts/fa-brands-400.woff2",
    "revision": "2ac01f7650b5ab76bfebbc708928929e"
  },
  {
    "url": "/frontend/fonts/fa-regular-400.eot",
    "revision": "93cd9a877c794fe87f8ce84f189d304f"
  },
  {
    "url": "/frontend/fonts/fa-regular-400.svg",
    "revision": "649582a6076b3294a23dddc20b23f356"
  },
  {
    "url": "/frontend/fonts/fa-regular-400.ttf",
    "revision": "8473867ab90a0a07178c173123a9bb83"
  },
  {
    "url": "/frontend/fonts/fa-regular-400.woff",
    "revision": "960d05e6858e73ff1caaa11cd5ba5363"
  },
  {
    "url": "/frontend/fonts/fa-regular-400.woff2",
    "revision": "12717b4a013de862452c4ffcf4e1c264"
  },
  {
    "url": "/frontend/fonts/fa-solid-900.eot",
    "revision": "303dc0631c4578227ea986e8832d3ad3"
  },
  {
    "url": "/frontend/fonts/fa-solid-900.ttf",
    "revision": "1af49f83f4cbc0fb391659b71b3a21dc"
  },
  {
    "url": "/frontend/fonts/fa-solid-900.woff",
    "revision": "2ebe0c1f8e212023f851f1ec3a2778eb"
  },
  {
    "url": "/frontend/fonts/fa-solid-900.woff2",
    "revision": "84f351b3972185aed620f78489e48b2d"
  },
  {
    "url": "/frontend/fonts/fontawesome-webfont.eot",
    "revision": "25a32416abee198dd821b0b17a198a8f"
  },
  {
    "url": "/frontend/fonts/fontawesome-webfont.ttf",
    "revision": "1dc35d25e61d819a9c357074014867ab"
  },
  {
    "url": "/frontend/fonts/fontawesome-webfont.woff",
    "revision": "c8ddf1e5e5bf3682bc7bebf30f394148"
  },
  {
    "url": "/frontend/fonts/fontawesome-webfont.woff2",
    "revision": "e6cf7c6ec7c2d6f670ae9d762604cb0b"
  },
  {
    "url": "/frontend/fonts/glyphicons-halflings-regular.eot",
    "revision": "f4769f9bdb7466be65088239c12046d1"
  },
  {
    "url": "/frontend/fonts/glyphicons-halflings-regular.svg",
    "revision": "89889688147bd7575d6327160d64e760"
  },
  {
    "url": "/frontend/fonts/glyphicons-halflings-regular.ttf",
    "revision": "e18bbf611f2a2e43afc071aa2f4e1512"
  },
  {
    "url": "/frontend/fonts/glyphicons-halflings-regular.woff",
    "revision": "fa2772327f55d8198301fdb8bcfc8158"
  },
  {
    "url": "/frontend/fonts/glyphicons-halflings-regular.woff2",
    "revision": "448c34a56d699c29117adc64c43affeb"
  },
  {
    "url": "/frontend/fonts/slick.eot",
    "revision": "ced611daf7709cc778da928fec876475"
  },
  {
    "url": "/frontend/fonts/slick.svg",
    "revision": "f97e3bbf73254b0112091d0192f17aec"
  },
  {
    "url": "/frontend/fonts/slick.ttf",
    "revision": "d41f55a78e6f49a5512878df1737e58a"
  },
  {
    "url": "/frontend/fonts/slick.woff",
    "revision": "b7c9e1e479de3b53f1e4e30ebac2403a"
  },
  {
    "url": "/frontend/images/25.gif",
    "revision": "3b2e6829cf2ac0a154cbe8a982ed1260"
  },
  {
    "url": "/frontend/images/ajax-loader.gif",
    "revision": "99e390c72524d78f1b37e15d104c02d8"
  },
  {
    "url": "/frontend/images/ajax-loader1.gif",
    "revision": "01000918725acebd286de3787fca4ee0"
  },
  {
    "url": "/frontend/images/arrow.jpg",
    "revision": "d223a6c375ff3858ba84684998950098"
  },
  {
    "url": "/frontend/images/bookb.jpg",
    "revision": "120bef8a5bdca0bf4f6af71c62c808f8"
  },
  {
    "url": "/frontend/images/bullet.jpg",
    "revision": "14627162f001234130c22e83b0431cc5"
  },
  {
    "url": "/frontend/images/chosen-sprite.png",
    "revision": "8b55a822e72b8fd5e2ee069236f2d797"
  },
  {
    "url": "/frontend/images/chosen-sprite@2x.png",
    "revision": "614fad616d014daf5367e068505cad35"
  },
  {
    "url": "/frontend/images/close.png",
    "revision": "d9d2d0b1308cb694aa8116915592e2a9"
  },
  {
    "url": "/frontend/images/ebook.png",
    "revision": "76df769617ff7425a67c6624ca449099"
  },
  {
    "url": "/frontend/images/go.jpg",
    "revision": "738aeec432b8d6f61cb9aed0e3023e8c"
  },
  {
    "url": "/frontend/images/header_border_right.jpg",
    "revision": "34c0f571ab9a1dd555a9548159267abb"
  },
  {
    "url": "/frontend/images/header_top_bg.jpg",
    "revision": "a2ded2fd29fdff8e9c5554cf7d1d17f5"
  },
  {
    "url": "/frontend/images/loading.gif",
    "revision": "2299ad0b3f63413f026dfec20c205b8f"
  },
  {
    "url": "/frontend/images/logo.jpg",
    "revision": "c92fd602aa45fd20974420de706ce3aa"
  },
  {
    "url": "/frontend/images/next.png",
    "revision": "31f15875975aab69085470aabbfec802"
  },
  {
    "url": "/frontend/images/prev.png",
    "revision": "84b76dee6b27b795e89e3649078a11c2"
  },
  {
    "url": "/frontend/images/redbullet.jpg",
    "revision": "2509476fed8d613923110f9c0a464d34"
  },
  {
    "url": "/frontend/images/search_alphabet.jpg",
    "revision": "162d04d4b43f782437bc78eead8b9634"
  },
  {
    "url": "/frontend/images/sort_asc.png",
    "revision": "9326ad44ae4bebdedd141e7a53c2a730"
  },
  {
    "url": "/frontend/images/sort_asc_disabled.png",
    "revision": "d7dc10c78f23615d328581aebcd805eb"
  },
  {
    "url": "/frontend/images/sort_both.png",
    "revision": "9a6486086d09bb38cf66a57cc559ade3"
  },
  {
    "url": "/frontend/images/sort_desc.png",
    "revision": "1fc418e33fd5a687290258b23fac4e98"
  },
  {
    "url": "/frontend/images/sort_desc_disabled.png",
    "revision": "bda51e15154a18257b4f955a222fd66f"
  },
  {
    "url": "/frontend/images/third.png",
    "revision": "a8a0ca78beefa842f6886792b0d8374e"
  },
  {
    "url": "/frontend/images/ui-bg_glass_100_f8f8f8_1x400.png",
    "revision": "39531d4aa106fb4a3db5b6ac6d3c0be6"
  },
  {
    "url": "/frontend/images/ui-bg_glass_35_dddddd_1x400.png",
    "revision": "6bf535dbb665b2633a444c7bd6a80d23"
  },
  {
    "url": "/frontend/images/ui-bg_glass_60_eeeeee_1x400.png",
    "revision": "2d4422a45c1120840e95df68dce00d52"
  },
  {
    "url": "/frontend/images/ui-bg_inset-hard_75_999999_1x100.png",
    "revision": "9d23d8df9718856b62e5d3a62983e9ce"
  },
  {
    "url": "/frontend/images/ui-bg_inset-soft_50_c9c9c9_1x100.png",
    "revision": "cc26d5b06d3e7a91d0dac633c159865d"
  },
  {
    "url": "/frontend/images/ui-icons_0073ea_256x240.png",
    "revision": "e99a91b64b31b2231f9258291c90069d"
  },
  {
    "url": "/frontend/images/ui-icons_2e83ff_256x240.png",
    "revision": "764c37efbf6d7ffc176b466fadc6f2ca"
  },
  {
    "url": "/frontend/images/ui-icons_3383bb_256x240.png",
    "revision": "90a1c1993882ff7e5740b5e802955cb5"
  },
  {
    "url": "/frontend/images/ui-icons_454545_256x240.png",
    "revision": "94c724823374be623fd19618399116e5"
  },
  {
    "url": "/frontend/images/ui-icons_70b2e1_256x240.png",
    "revision": "45f25ac98cb2e7929e688dff228e6a46"
  },
  {
    "url": "/frontend/images/ui-icons_999999_256x240.png",
    "revision": "d19e43f4fc52504dbf4b4195405eefeb"
  },
  {
    "url": "/frontend/images/ui-icons_fbc856_256x240.png",
    "revision": "c73cd11ca23193a958936ed9c682053e"
  },
  {
    "url": "/frontend/images/yellow.jpg",
    "revision": "51f9e309e73ff36a1ebc944fe02fba85"
  },
  {
    "url": "/frontend/js/bootstrap-datepicker.js",
    "revision": "07a4d1f88e9f34025a0edb96772e1279"
  },
  {
    "url": "/frontend/js/bootstrap.min.js",
    "revision": "5869c96cc8f19086aee625d670d741f9"
  },
  {
    "url": "/frontend/js/bootstrap4.min.js",
    "revision": "4c723f3a80b935e5e37ec46940bad17f"
  },
  {
    "url": "/frontend/js/chosen.jquery.min.js",
    "revision": "57655d5685e3fbd591350cb803b612ff"
  },
  {
    "url": "/frontend/js/dataTables.bootstrap.min.js",
    "revision": "63b062ca2b0c3f964a6441b525195161"
  },
  {
    "url": "/frontend/js/dataTables.jqueryui.min.js",
    "revision": "61d20aa3ba2c35ed1fa355d243fd8d05"
  },
  {
    "url": "/frontend/js/dataTables.responsive.js",
    "revision": "11ce3e94e64e2857f52d140951bea9a8"
  },
  {
    "url": "/frontend/js/dataTables.responsive.min.js",
    "revision": "bdb039670e0e12184b724f01c69a40a1"
  },
  {
    "url": "/frontend/js/easing.min.js",
    "revision": "d64116a742887080b3a0abd09e0bdad7"
  },
  {
    "url": "/frontend/js/flot-data.js",
    "revision": "af59bd75d28a4851d8f251d3d2f6ddbb"
  },
  {
    "url": "/frontend/js/jquery-2.2.2.min.js",
    "revision": "1d35678c5edbb639ab7aa5cce0856f57"
  },
  {
    "url": "/frontend/js/jquery-ui.min.js",
    "revision": "225b7cc33c34aec38fbd1c0977d26780"
  },
  {
    "url": "/frontend/js/jquery.autocomplete.min.js",
    "revision": "350d2be22fe9712eacaae0432e2dc1c5"
  },
  {
    "url": "/frontend/js/jquery.dataTables.min.js",
    "revision": "21131b35f3c138ca761d64707263dfd5"
  },
  {
    "url": "/frontend/js/jquery.flot.js",
    "revision": "89bc8ea971e99653717fa69a73d70bb4"
  },
  {
    "url": "/frontend/js/jquery.form.min.js",
    "revision": "f448c593c242d134e9733a84c7a4d26c"
  },
  {
    "url": "/frontend/js/jquery.inview.min.js",
    "revision": "be435d68c8a834ca6ffec6b6a054bdec"
  },
  {
    "url": "/frontend/js/jquery.lazy.min.js",
    "revision": "71fe4cbc9ec244193ad37556ee85cdd8"
  },
  {
    "url": "/frontend/js/jquery.marquee.min.js",
    "revision": "f2619ff525e29847f931bdfe1c428e1f"
  },
  {
    "url": "/frontend/js/jquery.min.js",
    "revision": "05e51b1db558320f1939f9789ccf5c8f"
  },
  {
    "url": "/frontend/js/jquery.twbsPagination.min.js",
    "revision": "708baa039a198873c48b73a06bd198fb"
  },
  {
    "url": "/frontend/js/lightbox.min.js",
    "revision": "754f3b83f87764db45e3adafea8c5720"
  },
  {
    "url": "/frontend/js/metisMenu.min.js",
    "revision": "9d596cdad6a6e250ced46785d04adf4e"
  },
  {
    "url": "/frontend/js/morris-data.js",
    "revision": "8b8aa49ae4db6905f614d0d7b0b60adb"
  },
  {
    "url": "/frontend/js/morris.min.js",
    "revision": "fadac462637afd6cdc0cb0a0137629af"
  },
  {
    "url": "/frontend/js/nouislider.min.js",
    "revision": "dd19d897f5ee7cfca3543be98595fef1"
  },
  {
    "url": "/frontend/js/nprogress.js",
    "revision": "094e662d40f0e2a40698a857178a5f01"
  },
  {
    "url": "/frontend/js/raphael.min.js",
    "revision": "1a032ef683f9ce4ccd105f87378163cc"
  },
  {
    "url": "/frontend/js/responsive.bootstrap.min.js",
    "revision": "29b6abedaae1510684dd687cd6aee887"
  },
  {
    "url": "/frontend/js/sb-admin-2.min.js",
    "revision": "1a996cc642439d9f907b10e20b479cf8"
  },
  {
    "url": "/frontend/js/script.js",
    "revision": "37be51fdf35341b3abf357227116350c"
  },
  {
    "url": "/frontend/js/slick.min.js",
    "revision": "d5a61c749e44e47159af8a6579dda121"
  },
  {
    "url": "/frontend/js/sweetalert2.all.min.js",
    "revision": "31f816aeeba57b707b38a24dca1d6145"
  },
  {
    "url": "/frontend/js/webcam.min.js",
    "revision": "8c19ef8866fa8eebca66baa5401be65d"
  },
  {
    "url": "/frontend/js/webcam.swf",
    "revision": "097e2bdcd17447390bd1caed7fa2934f"
  },
  {
    "url": "/frontend/uploads/adds/add.jpg",
    "revision": "6d9622d37489fa2672725e186464514a"
  },
  {
    "url": "/frontend/uploads/adds/add1.jpg",
    "revision": "6d9622d37489fa2672725e186464514a"
  },
  {
    "url": "/frontend/uploads/banner.jpg",
    "revision": "432b8df21ec82dc534c985f141553cf3"
  },
  {
    "url": "/img/144.png",
    "revision": "ba58743f0c5b0c5352d1b0971d16cd8f"
  },
  {
    "url": "/img/192.png",
    "revision": "13c4e7422a9519670adcc41466398048"
  },
  {
    "url": "/img/512.png",
    "revision": "89b06cda9a0d1f5c57e003c968a65e83"
  },
  {
    "url": "/img/72.png",
    "revision": "f6a76463405663a8463b11a3a65c7dd9"
  },
  {
    "url": "/img/96.png",
    "revision": "af21003655f4df2b396ad7fda92dc59d"
  },
  {
    "url": "/index.html",
    "revision": "57cfd8d95c9abf17f983eb00e3a2d55b"
  },
  {
    "url": "/js/203.9b54d8f0.js",
    "revision": null
  },
  {
    "url": "/js/315.63d59a8c.js",
    "revision": null
  },
  {
    "url": "/js/375.b3a53876.js",
    "revision": null
  },
  {
    "url": "/js/74.48712c33.js",
    "revision": null
  },
  {
    "url": "/js/848.09712491.js",
    "revision": null
  },
  {
    "url": "/js/app.5b9ed4b7.js",
    "revision": null
  },
  {
    "url": "/js/chunk-vendors.65e573de.js",
    "revision": null
  },
  {
    "url": "/manifest.json",
    "revision": "f14f9bfd0e9568933ef4b5b0249eb239"
  },
  {
    "url": "/robot.sty",
    "revision": "1860b5c469ba6c0d31c2df31a9a8b235"
  },
  {
    "url": "/robots.txt",
    "revision": "b6216d61c03e6ce0c9aea6ca7808f7ca"
  }
], {});








